import { Info } from '@berlitz/icons'
import Spacer from '@berlitz/spacer'
import { StoreProps } from '@interfaces/StoreState'
import { useRouter } from 'next/router'
import Link from 'next/link'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { CardLinkProps } from './interface'
import { CircleIconLoader, TextLoader } from './Loader'
import { Body, ButtonSmaller, Content, Icon, InfoWrapper, StyledA, StyledCard, Title, Wrapper } from './style'

const CardLink: React.FC<CardLinkProps> = ({
  id,
  children,
  icon,
  title,
  loading,
  color,
  info,
  img,
  iconColor,
  link,
  buttonText,
  onClick,
}) => {
  const { SFId } = useSelector(({ userProfile }: StoreProps) => ({
    SFId: userProfile?.info?.SFId,
  }))
  const router = useRouter()
  const body = (
    <StyledCard color={color}>
      <Content onClick={onClick}>
        {img && (
          <Wrapper>
            <img style={{ maxWidth: 300 }} src={img} alt="Berlitz" width={'100%'} />
          </Wrapper>
        )}
        <Wrapper>
          {loading ? (
            <>
              <CircleIconLoader />
              <TextLoader />
            </>
          ) : (
            <>
              <Icon iconColor={iconColor}>{icon}</Icon>
              {title && (
                <Title>
                  <FormattedMessage id={title} />
                </Title>
              )}
            </>
          )}
        </Wrapper>
        {info && (
          <Wrapper>
            <InfoWrapper>
              <Info size="xs" /> <FormattedMessage id={info} />
            </InfoWrapper>
          </Wrapper>
        )}
        {buttonText && (
          <>
            <Spacer size="md" />
            <ButtonSmaller outline>
              <FormattedMessage id={buttonText} />
            </ButtonSmaller>
          </>
        )}
        <Wrapper>{!loading && <Body>{children}</Body>}</Wrapper>
      </Content>
    </StyledCard>
  )

  if (!link && onClick) {
    return <StyledA>{body}</StyledA>
  }

  if (!link) {
    return body
  }

  if (id === 'book-single-lesson-card') {
    return (
      <a
        onClick={() => {
          localStorage.setItem(`${SFId}-lpid`, 'null')
          router.push(link)
        }}
      >
        <StyledA>{body}</StyledA>
      </a>
    )
  }

  return (
    <Link href={link} legacyBehavior>
      <StyledA>{body}</StyledA>
    </Link>
  )
}

export default CardLink
